import React, { useState, useEffect } from 'react';
import { useParams, ScrollRestoration,useLocation } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import InfoButton from './InfoButton'
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'

// Hook
import useAuth from '../hooks/useAuth';
import { useWarehouseListFetch } from '../hooks/useWarehouseListFetch';
// Image

import Grid from './Grid';

let renderCount = 0

const WarehouseList =  () => {
  const auth = useAuth();
  const location = useLocation();
  const from = location.state?.from || "./";
  console.log("from = "+from)
   const [includeSwitch, setIncludeSwitch] = useState(false)
  
 
  const { statewh, loadingwh, errorwh,setSearchValuewh,setIncludeInactivewh,setLoadingwh,setTriggerwh} = useWarehouseListFetch();
  
  const handleScroll = () =>{
    // // const element = document.getElementById(id?id:"")
    // // console.log("handlescroll is getrigger")
    // // console.log(element)
    // // if(element){
    // //   element.scrollIntoView({
       
    // //   })

    // }

  }


  const handleClick= async (e)=>{

      try {

        // eslint-disable-next-line no-restricted-globals
        const confirmation = confirm("Are you sure you want to Delete this warehouse? This action cannot be overturned!")
        if(confirmation){
        setTriggerwh(true)

        console.log("Sukses, die warehouse gaan delete word hier")
        await API.deleteWarehouse(e.target.id,auth.auth.accessToken)
        
      }else{
        return
      }
      } catch (error) {
          console.log(error)
      }
          
      console.log("gekliek op" + e.target.id)
      console.log(auth.auth.user.username)

  }

  useEffect(()=>{

    if(!loadingwh){
      handleScroll()
    }

  },[statewh])

  const username = auth.auth.user.username
  
  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(statewh)
 
  renderCount++
  return (
    <>
     
      <Header username={username} role={access} destination={from}></Header>
      
      {access==="administrator"?
         <Knoppie
         destination={`/addNewWarehouse`}
         text={'Add new Warehouse'}
         clickable={true}
         from={'../WarehouseList'}
         />
      :""}

        {/* <h1>RenderCount {renderCount/2}</h1> */}
        <SearchBar key={1}  setSearchValue={setSearchValuewh}></SearchBar>
        <List header={`Warehouses ${statewh.warehouses.length}` }
          destination={''}>
            <ButtonGrid>
            <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === true}
            callback={() => {
              setIncludeInactivewh(true)
              setIncludeSwitch(true)
            }}
            />
            <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === false}
            callback={() => {
              setIncludeInactivewh(false)
              setIncludeSwitch(false)
            }}
            />
          </ButtonGrid>
        {errorwh?"error":""}
        <Thumb
          name={"Warehouse"}
          
          
        >
        </Thumb>
        
        
        {loadingwh?<h1>...Loading</h1>:""}
        
        {statewh.warehouses.length>0 ? (
        <>
        {statewh.warehouses.map(item => (
         
         <>
         <div>
          <Thumb
            // onclick={setElementid(employee._id)}
            key={item._id}
            clickable={true}
            name={item.name}
            
            root={'warehouse'}
            from={'WarehouseList'}
            id={item._id}
            employeeid={item._id}
        
            >
              
          { <Knoppie
            clickable={true}
            text={"Delete"}
            destination={'../WarehouseList'}
            employeeid={item._id}
            callback={handleClick}
            >

            </Knoppie> }

            

            </Thumb>
            

            </div>
            </>
            
          ))}
        </>
        ):
        <div>No Warehouses found.</div>
        
        }  

          </List>     
          
    </>
  );
};

export default WarehouseList;

